
<div class="budget-add hmd-btn">
  <a-button type="primary" @click="visible=true">新增施工预算工程量</a-button>
  <a-modal
    v-model:visible="visible"
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    title="新增施工预算工程量"
    width="534px"
  >
    <template #footer>
      <a-button @click="submit(0)"> 保存并关闭 </a-button>
      <a-button type="primary" @click="submit(1)"> 保存并继续 </a-button>
    </template>

    <a-form
      ref="formRef"
      :model="formModel"
      :rules="formRules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-item label="清单编号：" v-bind="validateInfos.bizNo">
        <a-input
          v-model:value="formModel.bizNo"
          placeholder="请输入"
          style="width: 360px"
          :maxlength="50"
        ></a-input>
      </a-form-item>

      <a-form-item label="清单名称：" v-bind="validateInfos.name">
        <a-input
          v-model:value="formModel.name"
          placeholder="请输入"
          style="width: 360px"
          :maxlength="150"
        ></a-input>
      </a-form-item>
      <a-form-item label="项目特征：" v-bind="validateInfos.feature">
        <a-textarea
          v-model:value="formModel.feature"
          placeholder="请输入"
          style="width: 360px"
          :maxlength="500"
        ></a-textarea>
      </a-form-item>
      <a-form-item label="结算单位：" v-bind="validateInfos.unit">
        <a-input
          v-model:value="formModel.unit"
          placeholder="请输入"
          style="width: 360px"
          :maxlength="10"
        ></a-input>
      </a-form-item>
      <a-form-item label="工程量：" v-bind="validateInfos.budgetCount">
        <a-input-number
          v-model:value="formModel.budgetCount"
          placeholder="请输入"
          style="width: 360px"
          :precision="4"
          :maxLength="8"
        ></a-input-number>
      </a-form-item>
      <a-form-item label="综合单价：" v-bind="validateInfos.budgetPrice">
        <a-input-number
          v-model:value="formModel.budgetPrice"
          placeholder="请输入"
          style="width: 360px"
          :precision="4"
          maxLength="12"
        ></a-input-number>
      </a-form-item>
      <a-form-item label="合价(￥)：" v-bind="validateInfos.budgetTotalPrice">
        <div>{{ budgetTotalPrice }}元</div>
      </a-form-item>

      <a-form-item label="备注：" v-bind="validateInfos.remark">
        <a-textarea
          v-model:value="formModel.remark"
          placeholder="请输入备注"
          style="width: 360px"
          :maxlength="100"
        ></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</div>
